import React, { useEffect, useState } from 'react';
import { MapPin, Check, ChevronDown, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function ZipCodeFilter() {
  const [isOpen, setIsOpen] = useState(false);
  const [zipCode, setZipCode] = useState('');
  const [activeZip, setActiveZip] = useState<string | null>(null);
  const [locationName, setLocationName] = useState('');
  const [recentZips, setRecentZips] = useState([{
    code: '01310-100',
    name: 'Av. Paulista, SP'
  }, {
    code: '20040-002',
    name: 'Centro, RJ'
  }, {
    code: '30140-071',
    name: 'Savassi, MG'
  }]);
  const formatZip = (value: string) => {
    return value.replace(/\D/g, '').replace(/^(\d{5})(\d)/, '$1-$2').substr(0, 9);
  };
  const handleApply = () => {
    if (zipCode.length === 9) {
      setActiveZip(zipCode);
      // Mock location lookup
      setLocationName('São Paulo, SP');
      setIsOpen(false);
    }
  };
  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    setActiveZip(null);
    setLocationName('');
    setZipCode('');
  };
  return <div className="relative" data-id="element-351">
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all border ${activeZip ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-white text-slate-600 border-slate-200 hover:border-navy-300'}`} data-id="element-352">
        <MapPin className={`h-4 w-4 ${activeZip ? 'text-emerald-600' : 'text-slate-400'}`} data-id="element-353" />
        <span className="truncate max-w-[140px]" data-id="element-354">
          {activeZip ? `${activeZip} - ${locationName}` : 'Filtrar por CEP'}
        </span>
        {activeZip ? <X className="h-4 w-4 text-emerald-500 hover:text-emerald-700 ml-1" onClick={handleClear} data-id="element-355" /> : <ChevronDown className="h-3 w-3 text-slate-400 ml-1" data-id="element-356" />}
      </button>

      <AnimatePresence data-id="element-357">
        {isOpen && <>
            <div className="fixed inset-0 z-30" onClick={() => setIsOpen(false)} data-id="element-358" />
            <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 10
        }} className="absolute top-full left-0 mt-2 w-72 bg-white rounded-xl shadow-xl border border-slate-200 z-40 p-4" data-id="element-359">
              <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3" data-id="element-360">
                Monitoramento Regional
              </h3>

              <div className="flex gap-2 mb-4" data-id="element-361">
                <input type="text" value={zipCode} onChange={e => setZipCode(formatZip(e.target.value))} placeholder="00000-000" className="flex-1 px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-navy-900" maxLength={9} data-id="element-362" />
                <button onClick={handleApply} disabled={zipCode.length < 9} className="px-3 py-2 bg-navy-900 text-white rounded-lg text-sm font-medium disabled:opacity-50 hover:bg-navy-800 transition-colors" data-id="element-363">
                  Aplicar
                </button>
              </div>

              {recentZips.length > 0 && <div data-id="element-364">
                  <p className="text-xs text-slate-400 mb-2" data-id="element-365">Recentes</p>
                  <div className="space-y-1" data-id="element-366">
                    {recentZips.map(zip => <button key={zip.code} onClick={() => {
                setZipCode(zip.code);
                setActiveZip(zip.code);
                setLocationName(zip.name);
                setIsOpen(false);
              }} className="w-full flex items-center justify-between px-2 py-1.5 hover:bg-slate-50 rounded-md text-sm text-slate-600 group" data-id="element-367">
                        <span className="flex items-center" data-id="element-368">
                          <MapPin className="h-3 w-3 mr-2 text-slate-400 group-hover:text-navy-900" data-id="element-369" />
                          {zip.code}
                        </span>
                        <span className="text-xs text-slate-400" data-id="element-370">
                          {zip.name}
                        </span>
                      </button>)}
                  </div>
                </div>}
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}